import * as React from "react";

import { constantFormat } from "../../../../helpers/constants";
import { getProjectDocStatusPillStyle } from "../../../../helpers/mapping/ProjectDocStatusPillStyle";
import { getProjectDocTypePillStyle } from "../../../../helpers/mapping/ProjectDocTypePillStyle";
import { IconText } from "../../../../components/synced/ui/IconText/IconText";
import { Pill } from "../../../../components/synced/ui/Pill/Pill";
import { ProjectDoc } from "../../models/ProjectDoc";
import { resolveFieldData } from "../../../../helpers/utils/FieldDataResolver";
import styles from "./ProjectDocMobileCard.module.css";

export interface ProjectDocMobileCardProps {
  doc: ProjectDoc;
  onClick: () => void;
}

export const ProjectDocMobileCard: React.FC<ProjectDocMobileCardProps> = ({ doc, onClick }) => {
  const docTypeStyle = getProjectDocTypePillStyle(doc.DocTypeId);
  const statusStyle = getProjectDocStatusPillStyle(doc.StatusId);

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === `Enter` || e.key === ` `) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div className={styles.card} role="button" tabIndex={0} onClick={onClick} onKeyDown={onKeyDown}>
      <div className={styles.header}>
        <span className={styles.avatar}>
          <i className="fa-regular fa-file-lines" aria-hidden="true" />
        </span>
        <div className={styles.headerText}>
          <div className={styles.title}>{doc.Title}</div>
          <IconText
            icon="fa-regular fa-building"
            text={resolveFieldData(doc, `Project.Title`)}
            className={styles.project} />
        </div>
      </div>

      <div className={styles.pillRow}>
        <Pill icon="fa-regular fa-folder-open" label={resolveFieldData(doc, `DocType.Title`)} bg={docTypeStyle.bg} color={docTypeStyle.color} />
        <Pill label={resolveFieldData(doc, `Status.Title`)} bg={statusStyle.bg} color={statusStyle.color} dotColor={statusStyle.dot} />
      </div>

      <div className={styles.footer}>
        <IconText icon="fa-solid fa-briefcase" text={doc.CWContractorData} className={styles.contractor} />
        <span className={styles.date}>{doc.Created ? constantFormat.DateToString(doc.Created) : ``}</span>
      </div>
    </div>
  );
};
